import { queryOptions } from "@tanstack/react-query";
import { createServerFn, createServerOnlyFn } from "@tanstack/react-start";
import { vendureCacheConfig } from "@/api/vendure/cache.config";
import type { DeliveryMethod } from "@/api/vendure/merchant/merchant.types";
import { DELIVERY_METHOD_TYPE } from "@/api/vendure/merchant/merchant.types";
import { ORDER_SOURCE } from "@/api/vendure/order/order.types";
import { vendure } from "@/lib/vendure";
import type { MenuCategory, MenuResponse } from "./menu.types";

type MenuRequest = { token: string; type: number; timestamp?: number };

export const readMenu = createServerOnlyFn(
  async ({ token, type, timestamp }: MenuRequest): Promise<MenuCategory[]> => {
    const { data: response } = await vendure.get<MenuResponse>(
      `/api/v1/menu/business/${token}`,
      {
        params: {
          type,
          orderSource: ORDER_SOURCE,
          ...(timestamp ? { timestamp } : {}),
        },
      },
    );
    return response.result.categories ?? [];
  },
);

const fetchMenu = createServerFn({ method: "POST" })
  .inputValidator((d: MenuRequest) => d)
  .handler(({ data }): Promise<MenuCategory[]> => readMenu(data));

export const menuQueryOptions = (
  token: string,
  method: DeliveryMethod,
  timestamp?: number,
) =>
  queryOptions({
    queryKey: ["menu", token, method, timestamp ?? null],
    queryFn: () =>
      fetchMenu({
        data: { token, type: DELIVERY_METHOD_TYPE[method], timestamp },
      }),
    ...vendureCacheConfig,
    enabled: !!token,
  });
